import React from 'react';
import {
    Router,
    Route,
    Redirect,
    Switch
} from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';

import PrivateRoute from './scenes/RouteWrapper/PrivateRoute/PrivateRoute';
import AdminRoute from './scenes/RouteWrapper/AdminRoute/AdminRoute';
import EnquiryPage from './scenes/EnquiryPage/EnquiryPage';
import LoginPage from './scenes/LoginPage/LoginPage';
import DashboardPage from './scenes/DashboardPage/DashboardPage';
import ProfilePage from './scenes/DashboardPage/scenes/ProfilePage/ProfilePage';
import LeadPage from './scenes/DashboardPage/scenes/LeadPage/LeadPage';
import LeadManagementPage from './scenes/DashboardPage/scenes/LeadManagementPage/LeadManagementPage';
import ProgrammePage from './scenes/DashboardPage/scenes/ProgrammePage/ProgrammePage';
import ProgrammeManagementPage from './scenes/DashboardPage/scenes/ProgrammeManagementPage/ProgrammeManagementPage';
import ChannelPage from './scenes/DashboardPage/scenes/ChannelPage/ChannelPage';
import ChannelManagementPage from './scenes/DashboardPage/scenes/ChannelManagementPage/ChannelManagementPage';
import CustomerPage from './scenes/DashboardPage/scenes/CustomerPage/CustomerPage';
import CustomerManagementPage from './scenes/DashboardPage/scenes/CustomerManagementPage/CustomerManagementPage';
import IPointsSyncPage from './scenes/DashboardPage/scenes/IPointsSyncPage/IPointsSyncPage';
import ConsultantPage from './scenes/DashboardPage/scenes/ConsultantPage/ConsultantPage';
import ConsultantManagementPage from './scenes/DashboardPage/scenes/ConsultantManagementPage/ConsultantManagementPage';
import TeamManagementPage from './scenes/DashboardPage/scenes/TeamManagementPage/TeamManagementPage';
import ConfigPage from './scenes/DashboardPage/scenes/ConfigPage/ConfigPage';

const history = createBrowserHistory()

const adminSection = ({ match, ...rest }) => (
    <div>
		<Switch>
			<Route exact path={`${match.url}/programme`} component={ProgrammePage}/>
			<Route exact path={`${match.url}/programme/new`} component={ProgrammeManagementPage}/>
			<Route path={`${match.url}/programme/:programmeId`} component={ProgrammeManagementPage}/>
			<Route exact path={`${match.url}/channel`} component={ChannelPage}/>
			<Route exact path={`${match.url}/channel/new`} component={ChannelManagementPage}/>
			<Route path={`${match.url}/channel/:channelId`} component={ChannelManagementPage}/>
			<Route exact path={`${match.url}/customer`} component={CustomerPage}/>
			<Route exact path={`${match.url}/customer/new`} component={CustomerManagementPage}/>
			<Route path={`${match.url}/customer/:customerId`} component={CustomerManagementPage}/>
			<Route exact path={`${match.url}/ipoints-sync`} component={IPointsSyncPage}/>
			<Route exact path={`${match.url}/consultant`} component={ConsultantPage}/>
			<Route exact path={`${match.url}/consultant/new`} component={ConsultantManagementPage}/>
			<Route exact path={`${match.url}/consultant/team/new`} component={TeamManagementPage}/>
			<Route path={`${match.url}/consultant/team/:teamId`} component={TeamManagementPage}/>
			<Route path={`${match.url}/consultant/:consultantId`} component={ConsultantManagementPage}/>
			<Route exact path={`${match.url}/config/`} component={ConfigPage}/>
			<Redirect to={`${match.url}/ipoints-sync`}/>
		</Switch>
	</div>
)

const dashboard = ({ match, ...rest }) => (
    <DashboardPage match={match} {...rest}>
		<Switch>
			<Route exact path={`${match.url}/lead`} component={LeadPage}/>
			<Route exact path={`${match.url}/lead/new`} component={LeadManagementPage}/>
			<Route path={`${match.url}/lead/:leadId`} component={LeadManagementPage}/>
			<Route exact path={`${match.url}/profile`} component={ProfilePage}/>
			<AdminRoute path={`${match.url}/admin`} component={adminSection}/>
			<Redirect to={`${match.url}/lead`}/>
		</Switch>
	</DashboardPage>
)

const AppRouter = () => (
    <Router history={history}>
    	<Switch>
        	<Route exact path="/" render={() => {
	        		const token = localStorage.getItem('token')

	        		if (token)
	        			return <Redirect to="/dashboard"/>
	        		else {
	        			localStorage.removeItem('token')
	        			return <Redirect to="/login"/>
	        		}
        		}}
        	/>
    		<Route exact path="/enquiry" component={EnquiryPage}/>
			<Route exact path="/login" component={LoginPage}/>
			<PrivateRoute path="/dashboard" component={dashboard}/>
			<Redirect to="/"/>
        </Switch>
    </Router>
)

export default AppRouter


// WEBPACK FOOTER //
// ./src/router.js